"use client";

import { useGetV2OrganizationCompliance } from "@/gen/orval/webplatform/endpoints/organization/organization.gen";
import { useGetV2Organizations } from "@/gen/orval/webplatform/endpoints/organizations/organizations.gen";
import { ConnectionDropError } from "@/lib/utils/errors";

/* used for bypassing onboarding */
export function useGetFirstOrganizationCompliance() {
  const organizationCompliance = useGetV2OrganizationCompliance();
  const { data, isLoading } = organizationCompliance;

  if (!isLoading && !Array.isArray(data)) {
    throw new ConnectionDropError("Failed to load organization compliance");
  }

  return {
    firstOrganizationCompliance: {
      ...organizationCompliance,
      data: data?.[0],
    },
  };
}

export function useGetOrganization() {
  const organizationsRaw = useGetV2Organizations();
  const { data, isLoading, isSuccess } = organizationsRaw;

  if (!isLoading && !Array.isArray(data)) {
    throw new ConnectionDropError("Failed to load organizations data");
  }

  return {
    organization: data?.[0],
    organizationIsLoading: isLoading,
    organizationIsSuccess: isSuccess,
    organizationsRaw,
  };
}

export function useGetOrganizationCompliance() {
  const result = useGetV2OrganizationCompliance();

  const filterByScope = (scope: string) => {
    if (!result.isLoading && !Array.isArray(result.data)) {
      throw new ConnectionDropError("Failed to load organization compliance");
    }

    if (!result.isLoading && result.data) {
      return result.data.find((product) => product.scope === scope) ?? null;
    }

    return null;
  };

  return {
    mintredeemCompliance: {
      ...result,
      data: filterByScope("mintredeem"),
    },
    organizationCompliance: result,
    vendorCompliance: {
      ...result,
      data: filterByScope("vendor"),
    },
  };
}
